import { render, staticRenderFns } from "./problem-type.vue?vue&type=template&id=2cdefb1b&"
import script from "./problem-type.vue?vue&type=script&lang=js&"
export * from "./problem-type.vue?vue&type=script&lang=js&"
import style0 from "./problem-type.vue?vue&type=style&index=0&id=2cdefb1b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports